import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { BsBuilding, BsPerson } from 'react-icons/bs';

import SearchOverlay, { highlightMatch } from '#globalComponents/SearchOverlay/SearchOverlay';
import { useDebouncedValue } from '#globalHooks/useDebouncedValue';

import { useContactListSearch } from '../../models/queries';

const getItemKey = (item) => `${item.type}-${item.listId}-${item.entityId}`;

const ContactListSearchOverlay = () => {
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	const [query, setQuery] = useState('');

	const debouncedQuery = useDebouncedValue(query.trim());
	const { data, isFetching } = useContactListSearch(open ? debouncedQuery : '');

	const groups = [
		{ key: 'contacts', label: 'Kontakte', items: data?.contacts ?? [] },
		{ key: 'companies', label: 'Firmen', items: data?.companies ?? [] },
	];

	const handleSelect = (item) => {
		setQuery('');
		setOpen(false);
		const params = new URLSearchParams({ tab: item.tab, highlight: item.entityId });
		navigate(`/contact-lists/${item.listId}?${params}`);
	};

	const renderItem = (item) => {
		const Icon = item.type === 'contact' ? BsPerson : BsBuilding;
		const title = item.name || '—';
		const subtitleParts = item.type === 'contact' ? [item.companyName].filter(Boolean) : [];
		const showSnippet = item.matchedValue && item.matchedValue !== title;
		return (
			<>
				<Icon className="w-4 h-4 text-bgBase-800 flex-shrink-0 mt-0.5" />
				<div className="flex-1 min-w-0">
					<p className="text-sm font-medium text-text truncate">{highlightMatch(title, debouncedQuery)}</p>
					{subtitleParts.length > 0 && (
						<p className="text-[11px] text-bgBase-800 truncate mt-0.5">{subtitleParts.join(' · ')}</p>
					)}
					{showSnippet && (
						<p className="text-[11px] text-bgBase-800 truncate mt-0.5">
							{highlightMatch(item.matchedValue, debouncedQuery)}
						</p>
					)}
				</div>
				<span className="text-[10px] text-primary-700 bg-primary-100 rounded px-1.5 py-0.5 flex-shrink-0 mt-0.5 max-w-[10rem] truncate">
					{item.listName}
				</span>
			</>
		);
	};

	return (
		<SearchOverlay
			open={open}
			onOpenChange={setOpen}
			placeholder="Kontakte & Firmen suchen …"
			query={query}
			onQueryChange={setQuery}
			groups={groups}
			renderItem={renderItem}
			getItemKey={getItemKey}
			onSelect={handleSelect}
			isLoading={isFetching}
		/>
	);
};

export default ContactListSearchOverlay;
